import {
  Component,
  inject,
  input,
  OnInit,
  signal,
  WritableSignal,
} from '@angular/core';
import { CouponService } from '../../Services/coupon.service';
import { getCouponsResponse } from '../../models/Coupons/getCouponsResponse.model';
import { OrderService } from '../../Services/order.service';
import { LanguageService } from '../../Services/language.service';

@Component({
  selector: 'app-cupon',
  templateUrl: './cupon.component.html',
  styleUrl: './cupon.component.scss',
})
export class CuponComponent implements OnInit {
  CouponService = inject(CouponService);
  OrderService = inject(OrderService);

  isCuponClicked = false;
  Coupons: getCouponsResponse[] = [];

  userInput: string = '';

  menuItemId = input.required<number>();
  public languageService = inject(LanguageService);
  HowToGet: WritableSignal<string> = signal('');
  Coupon: WritableSignal<string> = signal('');
  Code: WritableSignal<string> = signal('');
  ApplyCoupon: WritableSignal<string> = signal('');
  Condition1: WritableSignal<string> = signal('');
  Condition2: WritableSignal<string> = signal('');
  Condition3: WritableSignal<string> = signal('');
  language = this.languageService.getLanguage();

  ngOnInit(): void {
    this.CouponService.getAllCoupons().subscribe({
      next: (response) => {
        this.Coupons = response;
      },
      error: (err) => {
        console.error(err);
      },
    });

    this.languageService.currentLanguage$.subscribe(() => {
      this.updateTitles();
    });
  }

  onCuponClicked() {
    this.isCuponClicked = !this.isCuponClicked;
  }

  goToInsta() {
    window.open('https://www.instagram.com/aradaistanbul/?hl=en', '_blank');
  }

  onEnter(): boolean {
    this.CouponService.checkMenuItemCoupon(this.menuItemId()).subscribe({
      next: (response) => {
        if (response >= 0) {
          this.OrderService.addOrder(this.menuItemId(), response);
          this.OrderService.updateOrder(this.menuItemId(), {
            price: response,
            discountedPrice: response,
            HasCoupon: true,
            isCouponApplied: true,
          });
        }
      },
      error: (err) => {
      //  console.log('error coupon check');
      },
    });

    if (this.Coupons.length > 0) {
      this.Coupons.forEach((coupon) => {
        if (
          coupon.couponCode.toLowerCase() === this.userInput.toLowerCase() &&
          coupon.menuItem.id === this.menuItemId()
        ) {
      //    console.log('Congrats You got the Discount!', this.userInput);
          this.userInput = '';
          this.OrderService.breakfastCoupon = true;
          return true;
        } else {
          return false;
        }
      });
    } else {
    //  console.log('There are no coupons');
      return false;
    }

    return false;
  }

  private updateTitles() {
    // Update titles based on the current language in the service
    this.HowToGet = this.languageService.HowToGet;
    this.Coupon = this.languageService.Coupon;
    this.Code = this.languageService.Code;
    this.ApplyCoupon = this.languageService.ApplyCoupon;
    this.Condition1 = this.languageService.Condition1;
    this.Condition2 = this.languageService.Condition2;
    this.Condition3 = this.languageService.Condition3;
    this.language = this.languageService.getLanguage();
  }

  goToGoogle(){
    window.open('https://g.page/r/CTVROCK-X-PuEBE/review', '_blank');
  }
}
